import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ProfileSetupModalComponent } from '@app/modules/dashboard/modules/owner/components/dashboard/profile-setup-modal/profile-setup-modal.component';
import { PlanExpiryPopupComponent } from './plan-expiry-popup/plan-expiry-popup.component';
import { BreadcrumbComponent } from '@shared/breadcrumb/breadcrumb.component';
import {
  BarChartComponent,
  ColumnsChartComponent,
  DonutChartComponent,
  EmptyChartComponent,
  LineChartComponent,
  MixedChartComponent,
  RadialbarChartComponent,
  SemiDonutChartComponent,
  TreemapChartComponent,
  TrendLineChartComponent
} from '@shared/chart';
import { DataNotFoundComponent } from '@shared/data-not-found/data-not-found.component';
import { DateRangePickerComponent } from '@shared/date-range-picker/date-range-picker.component';
import { AutoHeightDirective } from '@shared/directives/auto-height.directive';
import { SkipContentDirective } from '@shared/directives/skip-content.directive';
import { FooterComponent } from '@shared/footer/footer.component';
import { InvoicePaginationComponent } from '@shared/invoice-pagination/invoice-pagination.component';
import { NavbarComponent } from '@shared/navbar/navbar.component';
import { HorizontalBarRankingComponent } from '@shared/horizontal-bar-ranking/horizontal-bar-ranking.component';
import { NotFoundComponent } from '@shared/not-found/not-found.component';
import { RateRangeBarComponent } from '@shared/rate-range-bar/rate-range-bar.component';
import { SpendHeatmapComponent } from '@shared/spend-heatmap/spend-heatmap.component';
import {
  BsDatepickerModule,
  NgSelectModule,
  PaginationModule,
  PmdAccordionModule,
  PmdAlertModule,
  PmdButtonModule,
  PmdButtonToggleModule,
  PmdCardModule,
  PmdCheckboxModule,
  PmdCollapseModule,
  PmdDropdownModule,
  PmdFormGroupModule,
  PmdModalModule,
  PmdNavbarModule,
  PmdPopoverModule,
  PmdProgressbarModule,
  PmdRadioButtonModule,
  PmdRippleEffectModule,
  PmdSidebarModule,
  PmdSwitchModule,
  PmdTabsModule,
  PmdTooltipModule,
  RatingModule
} from '@shared/propeller';
import { SidebarComponent } from '@shared/sidebar/sidebar.component';
import { PmdFixedHeaderModule } from '@shared/table-header-fixed/fixed-header.module';
import { TableLoaderComponent } from '@shared/table-loader/table-loader.component';
import { ZoomComponent } from '@shared/zoom/zoom.component';
import { AngularDraggableModule } from 'angular2-draggable';
import { NgApexchartsModule } from "ng-apexcharts";
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { JoyrideModule } from 'ngx-joyride';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AdminCommonCompanyDropdownComponent } from './admin-common-company-dropdown/admin-common-company-dropdown.component';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { BlockCopyPasteDirective } from './directives/block-copy-paste.directive';
import { UppercaseDirective } from './directives/upper-case.directive';
import { FillCompanyDetailsComponent } from './fill-company-details/fill-company-details.component';
import { InvoiceExtractionComponent } from './invoice-extraction/invoice-extraction.component';
import { InvoiceViewerComponentComponent } from './invoice-viewer-component/invoice-viewer-component.component';
import { InvoiceQualityIssuePopoverComponent } from './invoice-quality-issue-popover/invoice-quality-issue-popover.component';
import { PdfZoomComponent } from './pdf-zoom/pdf-zoom.component';
import { CompactCurrencyPipe } from './pipes/compact-currency.pipe';
import { IstDateTimePipe, RelativeTimePipe, UploadDelayColorPipe } from './pipes/ist-date-time.pipe';
import { RemovePrefixPipe } from './pipes/file-format.pipe';
import { FilesizePipe } from './pipes/filesize.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TextDifferencePipe } from './pipes/text-difference.pipe';
import { ValidateInvoiceDatePipe } from './pipes/validate-invoice-date.pipe';
import { SidebarSubmenuComponent } from './sidebar-submenu/sidebar-submenu.component';
import { InvoiceBasicInfoComponent } from './invoice-basic-info/invoice-basic-info.component';
import { InvoiceTdsTcsComponent } from './invoice-tds-tcs/invoice-tds-tcs.component';
import { InvoiceReviewModalsComponent } from './invoice-review-modals/invoice-review-modals.component';
import { InvoiceRejectReasonModalComponent } from './invoice-reject-reason-modal/invoice-reject-reason-modal.component';



@NgModule({
  declarations: [
    BreadcrumbComponent,
    SkipContentDirective,
    AutoHeightDirective,
    FooterComponent,
    NavbarComponent,
    ZoomComponent,
    NotFoundComponent,
    SafeHtmlPipe,
    SidebarComponent,
    SidebarSubmenuComponent,
    DataNotFoundComponent,
    DateRangePickerComponent,
    TableLoaderComponent,
    InvoicePaginationComponent,
    DonutChartComponent,
    MixedChartComponent,
    SemiDonutChartComponent,
    RadialbarChartComponent,
    TreemapChartComponent,
    ColumnsChartComponent,
    EmptyChartComponent,
    LineChartComponent,
    BarChartComponent,
    TrendLineChartComponent,
    RateRangeBarComponent,
    HorizontalBarRankingComponent,
    SpendHeatmapComponent,
    ValidateInvoiceDatePipe,
    IstDateTimePipe,
    RelativeTimePipe,
    UploadDelayColorPipe,
    PdfZoomComponent,
    AutoFocusDirective,
    FilesizePipe,
    RemovePrefixPipe,
    TextDifferencePipe,
    CompactCurrencyPipe,
    BlockCopyPasteDirective,
    UppercaseDirective,
    FillCompanyDetailsComponent,
    InvoiceExtractionComponent,
    ProfileSetupModalComponent,
    PlanExpiryPopupComponent,
    AdminCommonCompanyDropdownComponent,
    InvoiceViewerComponentComponent,
    InvoiceBasicInfoComponent,
    InvoiceTdsTcsComponent,
    InvoiceReviewModalsComponent,
    InvoiceRejectReasonModalComponent,
    InvoiceQualityIssuePopoverComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    RouterModule,
    PmdNavbarModule,
    PmdSidebarModule,
    PmdCardModule,
    PmdCollapseModule.forRoot(),
    PmdDropdownModule.forRoot(),
    PmdFormGroupModule.forRoot(),
    PmdPopoverModule.forRoot(),
    PmdButtonModule,
    PmdTabsModule.forRoot(),
    PmdSwitchModule,
    PmdAccordionModule.forRoot(),
    PmdCheckboxModule,
    PmdTooltipModule.forRoot(),
    PmdAlertModule.forRoot(),
    PmdRippleEffectModule,
    PmdModalModule.forRoot(),
    PmdButtonToggleModule.forRoot(),
    PmdRadioButtonModule,
    PmdProgressbarModule.forRoot(),
    RatingModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgSelectModule,
    PaginationModule.forRoot(),
    NgApexchartsModule,
    PdfViewerModule,
    DragDropModule,
    AngularDraggableModule,
    JoyrideModule,
    CarouselModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    BreadcrumbComponent,
    SkipContentDirective,
    AutoHeightDirective,
    FooterComponent,
    NavbarComponent,
    ZoomComponent,
    NotFoundComponent,
    SafeHtmlPipe,
    CompactCurrencyPipe,
    SidebarComponent,
    SidebarSubmenuComponent,
    DataNotFoundComponent,
    DateRangePickerComponent,
    TableLoaderComponent,
    InvoicePaginationComponent,
    DonutChartComponent,
    MixedChartComponent,
    SemiDonutChartComponent,
    RadialbarChartComponent,
    TreemapChartComponent,
    ColumnsChartComponent,
    EmptyChartComponent,
    LineChartComponent,
    BarChartComponent,
    TrendLineChartComponent,
    RateRangeBarComponent,
    HorizontalBarRankingComponent,
    SpendHeatmapComponent,
    PdfZoomComponent,
    FillCompanyDetailsComponent,
    InvoiceExtractionComponent,
    ProfileSetupModalComponent,
    PlanExpiryPopupComponent,
    AdminCommonCompanyDropdownComponent,
    PmdNavbarModule,
    PmdSidebarModule,
    PmdCardModule,
    PmdCollapseModule,
    PmdDropdownModule,
    PmdFormGroupModule,
    PmdButtonModule,
    PmdTabsModule,
    PmdSwitchModule,
    PmdAccordionModule,
    PmdCheckboxModule,
    PmdTooltipModule,
    PmdAlertModule,
    PmdPopoverModule,
    PmdRippleEffectModule,
    PmdModalModule,
    PmdButtonToggleModule,
    PmdRadioButtonModule,
    PmdProgressbarModule,
    RatingModule,
    BsDatepickerModule,
    NgSelectModule,
    ValidateInvoiceDatePipe,
    IstDateTimePipe,
    RelativeTimePipe,
    UploadDelayColorPipe,
    PdfViewerModule,
    AutoFocusDirective,
    PmdFixedHeaderModule,
    DragDropModule,
    AngularDraggableModule,
    FilesizePipe,
    RemovePrefixPipe,
    TextDifferencePipe,
    BlockCopyPasteDirective,
    UppercaseDirective,
    JoyrideModule,
    NgApexchartsModule,
    SafeHtmlPipe,
    InvoiceViewerComponentComponent,
    CarouselModule,
    InvoiceBasicInfoComponent,
    InvoiceTdsTcsComponent,
    InvoiceReviewModalsComponent,
    InvoiceRejectReasonModalComponent,
    InvoiceQualityIssuePopoverComponent
  ]
})
export class SharedModule { }
